<template>
  <div class="h-100 w-100">
    <router-view/>
  </div>
</template>

<style>
html, body {
  height:100%;
}
body {
  display:flex;
  align-items:center;
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/messaging';
import localForage from 'localforage';

var config = {
  apiKey: "AIzaSyB5Wk-cVTvAfZqESa-6UJGQhPMdXA75D_o",
  authDomain: "dtac-call-4462d.firebaseapp.com",
  projectId: "dtac-call-4462d",
  messagingSenderId: "282740428167"
};
firebase.initializeApp(config);
var messaging = firebase.messaging();
messaging.usePublicVapidKey(
  "BFDuDeVB22kUIvButwgbMJt2_x2SsIXCSffgyN5gR5Z8sDo5aDewXyTcE3kQo5b_d3iISCh7rBx-HGysQNdFZu0"
);

export default {
 mounted(){
    messaging.onMessage(function(fcm) {
      let payload = fcm.data;
      console.log('Message received. ', payload);
      if (payload.action === "message") {

        let notificationTitle = payload.destination+' got New Message';
        let body = payload.body;
        let notificationOptions = {
          body: body,
          icon: '/img/dtaccall-logo.png',
          data: payload
        };
        
        setTimeout(function(){  
          localForage.getItem(payload.web_message_id,function (err, payloads) {
            console.log('Message storages', payloads);
              if ( payloads === null ) {
                localForage.setItem(payload.web_message_id,payload);
                let notification = new Notification(notificationTitle,notificationOptions);

                notification.onclick = function (event) {
                  console.log('event click:',event);
                    window.open('/message?id='+payload.web_message_id, "_blank", "toolbar=no,scrollbars=yes,resizable=yes,width=400,height=400");      
                };
              }
          });
        }, (Math.floor(Math.random() * 10) + 1)*100);
      }
      if (payload.action === "logout") {
        this.$router.push({ name: "logout" });
      }
    });
  }
}
</script>

<style>

</style>
